/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Grid } from "@mui/material";
import Box from "components/generals/Box";
import Button from "components/generals/Button";
import PermissionWrapper from "components/generals/PermissionWrapper";
import { StepperFormActionButtonsProps } from "interfaces";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EntityPermissions, PermissionsUser } from "types";

/**
 * Action buttons for multi-step form navigation.
 * Renders back, next, and submit buttons based on current step and form state.
 * Button labels adapt based on step position and special conditions (minor user).
 * @param {StepperFormActionButtonsProps<any>} props - Component props
 * @returns {React.ReactElement} Form navigation buttons (back, next/submit)
 */
const StepperFormActionButtons: FC<StepperFormActionButtonsProps<any>> = ({
  backStepHandler,
  nextStep,
  firstStep,
  isLoading,
  lastStep,
  disabledSubmit,
  minorUserChecked,
}) => {
  const { t } = useTranslation();
  const buttonLabel = (() => {
    if (nextStep) {
      return lastStep || minorUserChecked
        ? t("stepperFormActionButtons.submit")
        : t("stepperFormActionButtons.next");
    } else {
      return firstStep === undefined
        ? t("stepperFormActionButtons.save")
        : t("stepperFormActionButtons.submit");
    }
  })();

  return (
    <Grid item>
      <Box mt={2} width="100%" display="flex" justifyContent="space-between">
        {backStepHandler && !firstStep ? (
          <Button color="secondary" variant="contained" onClick={() => backStepHandler()}>
            {t("stepperFormActionButtons.back")}
          </Button>
        ) : (
          <Box />
        )}
        {buttonLabel.toLowerCase() === "next" || buttonLabel.toLowerCase() === "save" ? (
          <PermissionWrapper
            requiredPermissions={[
              PermissionsUser[EntityPermissions.NEW_PATIENTS].EDIT,
              PermissionsUser[EntityPermissions.NEW_DOCTORS].EDIT,
              PermissionsUser[EntityPermissions.USER_PROFILE].EDIT,
            ]}
          >
            <Button
              type="submit"
              variant="contained"
              color="info"
              disabled={isLoading || disabledSubmit}
              name="nextSaveStepperFormActionButtons"
            >
              {buttonLabel}
            </Button>
          </PermissionWrapper>
        ) : (
          <PermissionWrapper
            requiredPermissions={[
              PermissionsUser[EntityPermissions.NEW_PATIENTS].CREATE,
              PermissionsUser[EntityPermissions.NEW_DOCTORS].CREATE,
              PermissionsUser[EntityPermissions.USER_PROFILE].EDIT,
            ]}
          >
            <Button
              type="submit"
              variant="contained"
              color="info"
              disabled={isLoading || disabledSubmit}
              name="createStepperFormActionButtons"
            >
              {buttonLabel}
            </Button>
          </PermissionWrapper>
        )}
      </Box>
    </Grid>
  );
};

export default StepperFormActionButtons;
